import { Zoom, DualPage } from './shared/model/docavea-viewer-interface';
import { pdfReady, pagesinit, loadPdfPayload, pdfViewer } from './main';
import { Utils } from '../src/shared/extensions/utils.extension';
import { viewChanged } from './view-changed';
// import 'hammerjs';
import * as _ from 'lodash';
import { debug } from './debug';

const SCROLLBAR_WIDTH = 15;

let viewerContainerEl: HTMLElement;
let timeStamp = 0;

// setup zoom and pan event handlers
export function initMouseWheelZoom() {
    const _viewerContainerEl = document.getElementById('viewerContainer');

    if (_viewerContainerEl) {
        viewerContainerEl = _viewerContainerEl as HTMLElement;
    } else {
        console.error(`getElementById('viewerContainer') failed`);
        return;
    }
}

export function initMouseWheelZoomEvents() {
    viewerContainerEl.addEventListener('wheel', handleWheel);
}

export function calculateCurrentScale(page: any, oldZoom: Zoom) {
    let currentScaleValue: number;
    if (oldZoom === Zoom.SCALE) {
        currentScaleValue = +pdfViewer.currentScaleValue;
    } else {
        const noOfPagesSideBySide = loadPdfPayload.scalePayload.dualPage === DualPage.SINGLE ? 1 : 2;
        const pageViewport = page.getViewport({ scale: 1 });
        const rotated = pdfViewer._pages[pdfViewer.currentPageNumber - 1].rotation === 90 || pdfViewer._pages[pdfViewer.currentPageNumber - 1].rotation === 270;
        const pageHeight = rotated ? pageViewport.width : pageViewport.height;
        const pageWidth = rotated ? pageViewport.height : pageViewport.width;
        const containerHeight = viewerContainerEl.clientHeight;
        const containerWidth = (viewerContainerEl.clientWidth) / noOfPagesSideBySide - SCROLLBAR_WIDTH;

        if (oldZoom === Zoom.PAGE) {
            // currentScaleValue is set to a string: 'page-fit', so we need to calculate the value
            currentScaleValue = (72.0 / 96.0) * Math.min(containerWidth / pageWidth, containerHeight / pageHeight);
        } else {
            // currentScaleValue is set to a string: 'page-width', so we need to calculate the value
            currentScaleValue = (72.0 / 96.0) * containerWidth / pageWidth;
        }
    }

    return currentScaleValue;
}

export async function wheelZoom(delta: number, zoomPointX: number, zoomPointY: number) {
    const oldScrollLeft = viewerContainerEl.scrollLeft;
    const oldScrollTop = viewerContainerEl.scrollTop;

    let zoomFactor = delta < 0 ? 1.1 : 0.9;
    const pageNumber = await pdfReady();
    if (pageNumber < 0) {
        return;
    }
    const oldScale = calculateCurrentScale(pageNumber, loadPdfPayload.scalePayload.zoom);
    const newScale = _.clamp(oldScale * zoomFactor, loadPdfPayload.minScale, loadPdfPayload.maxScale);

    if (newScale !== oldScale) {
        zoomFactor = newScale / oldScale;  // Recalculate zoomFactor in case it was clamped
        pdfViewer.currentScaleValue = newScale;
        loadPdfPayload.scalePayload.scale = newScale;
        loadPdfPayload.scalePayload.zoom = Zoom.SCALE;

        const scrollLeft = Math.max((zoomPointX + oldScrollLeft) * zoomFactor - zoomPointX, 0);
        const scrollTop = Math.max((zoomPointY + oldScrollTop) * zoomFactor - zoomPointY, 0);
        viewerContainerEl.scrollTo(scrollLeft, scrollTop);
        debug('oldScrollLeft', oldScrollLeft, 'oldScrollTop', oldScrollTop, 'scrollLeft', scrollLeft, 'scrollTop', scrollTop, 'newScale', newScale);
    }

    await viewChanged(false, false);
}

const handleWheel = (event: WheelEvent) => {
    if (!pagesinit) { 
        return; 
    }

    if (event.ctrlKey) {
        event.preventDefault();
        if (Utils.isMacOs()) {
            // We must be on MAC using the touch pad on a non-Safari browser
            if (timeStamp === 0) { 
                timeStamp = event.timeStamp - 101; 
            }
            if ((event.timeStamp - timeStamp) > 100) {
                timeStamp = event.timeStamp;

                wheelZoom(event.deltaY, event.clientX, event.clientY);
            }
        } else {
            // We are not on a Mac using mouse-wheel+ctrl-key or a touch pad
            wheelZoom(event.deltaY, event.clientX, event.clientY);
        }
    } else if (Utils.isMacOs() && event.metaKey) {
        // We are on a MAc using the mouse-wheel+cmd-key
        event.preventDefault();
        wheelZoom(event.deltaY, event.clientX, event.clientY);
    }
};
